import countryCodes from './country-codes.json';

export const dialCodes: {
  dial_code: string;
  code: string;
  name: string;
}[] = countryCodes;
